module.exports = __webpack_public_path__ + "img/kbank-logo.51c5edd3.png";